import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SectionListComponent } from './components/section-list/section-list.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { GeneralBannersConfigurationComponent } from './components/banners-configuration/general-banners-configuration/general-banners-configuration.component';
import { BannerConfigComponent } from './components/banners-configuration/banner-config/banner-config.component';
import { BannersListComponent } from './components/banners-configuration/banners-list/banners-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SectionComponent } from './components/section/section.component';
import { BannersConfigurationComponent } from './components/banners-configuration/banners-configuration/banners-configuration.component';
import { SearchBoxHintConfigurationComponent } from './components/search-box-hint-configuration/search-box-hint-configuration.component';
import { SectionGeneralConfigurationComponent } from './components/section-general-configuration/section-general-configuration.component';
import { TopbarFiltersConfigurationComponent } from './components/topbar-filters-configuration/topbar-filters-configuration.component';
import { DataFilteringConfigurationComponent } from './components/data-filtering-configuration/data-filtering-configuration.component';
import { AppDataFilterComponent } from './components/data-filtering-configuration/apps-data-filter/apps-data-filter.component';
import { RulesDataFilterComponent } from './components/data-filtering-configuration/rules-data-filter/rules-data-filter.component';
import { AppGroupsConfigurationComponent } from './components/app-groups-configuration/app-groups-configuration.component';
import { AppGroupConfigurationComponent } from './components/app-groups-configuration/app-group-configuration/app-group-configuration.component';
import { VersionSelectorComponent } from './components/section-general-configuration/version-selector/version-selector.component';
import { MatChipsModule } from '@angular/material/chips';
import { ServicesFilterConfigurationComponent } from './components/topbar-filters-configuration/services-filter-configuration/services-filter-configuration.component';
import { NoDataLabelConfigurationComponent } from './components/no-data-label-configuration/no-data-label-configuration.component';


@NgModule({
  declarations: [
    SectionListComponent,
    BannersConfigurationComponent,
    GeneralBannersConfigurationComponent,
    BannerConfigComponent,
    BannersListComponent,
    VersionSelectorComponent,
    SectionComponent,
    SearchBoxHintConfigurationComponent,
    SectionGeneralConfigurationComponent,
    TopbarFiltersConfigurationComponent,
    DataFilteringConfigurationComponent,
    AppDataFilterComponent,
    RulesDataFilterComponent,
    AppGroupsConfigurationComponent,
    AppGroupConfigurationComponent,
    ServicesFilterConfigurationComponent,
    NoDataLabelConfigurationComponent    
  ],
  imports: [
    SharedModule,
    MatExpansionModule,
    DragDropModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule
  ],
  exports: []
})
export class SectionConfigurationModule { }
